<template>
  <hm-content title="">
    <div class="flex flex-wrap">
      <div
        class="act-content bg-purple pointer"
        v-for="(v, i) in list"
        :key="i"
        @click="createdGame(v)"
      >
        <div style="width: 250px;">
          <img style="width: 100%" :src="v.img" alt />
        </div>

        <div class="flex flex-between">
          <el-tooltip placement="bottom" :content="v.content">
            <div class="acttitle flex-1" style="line-height:24px">{{ v.content }}</div>
          </el-tooltip>
          <div class="add-wrapper small">
            <span class="hmicon icon-hao pointer"></span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="row.title"
      :visible.sync="dialogVisible"
    >
      <div class="flex flex-warp">
        <div class="gameImg">
          <img style="width: 100%; height: 100%" :src="row.bgimg" alt />
        </div>
        <div class="introduce flex flex-column flex-between flex-1">
          <div>
            <div>
              <p>玩法介绍</p>
              <span>{{ row.introduce }}</span>
            </div>
            <div class="mt20">
              <p>营销功能</p>
              <el-tag type="info" v-if="row.spreadTarget ==='medal'">极速审核</el-tag>
              <div v-else>
                <el-tag type="info" v-if="row.spreadTarget ==='redpackageVideoAd'">提升收益</el-tag>
                <el-tag type="info" v-if="row.spreadTarget !=='redpackageVideoAd'">病毒营销</el-tag>
                <el-tag type="info" v-if="row.spreadTarget !=='redpackageVideoAd'">吸引供应商</el-tag>
              </div>
              
            </div>
          </div>
          <div class="mt10 flex flex-center">
            <el-button size="medium" type="primary" @click="toMyActivity(row)"
              >我的活动</el-button
            >
            <el-button size="medium" type="primary" @click="toCreateActivity()"
              >创建活动</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      row: {},
      list: [
        {
          title: "导购邀请供应商奖励活动",
          content: "导购邀请供应商奖励活动",
          img:
            "https://imgcdn.hemiao100.com/ThemePictures/banner%402x%402x.png",
          bgimg:
            "https://imgcdn.hemiao100.com/ThemePictures/%E9%82%80%E8%AF%B7%E9%A2%86%E7%8E%B0%E9%87%91%402x.png",
          introduce: "导购邀请供应商奖励活动",
          spreadTarget: "guider",
          activityFrom: "MyActivity",
          query: "turntable"
        },
        {
          title: "业务员邀请供应商奖励活动",
          content: "业务员邀请供应商奖励活动",
          img:
            "https://imgcdn.hemiao100.com/ThemePictures/banner1%402x%402x.png",
          bgimg:
            "https://imgcdn.hemiao100.com/ThemePictures/%E9%82%80%E8%AF%B7%E9%A2%86%E7%8E%B0%E9%87%91%402x.png",
          introduce: "业务员邀请供应商奖励活动",
          spreadTarget: "supplier",
          activityFrom: "MyActivity",
          query: "turntable"
        },
        {
          title: "采购邀请供应商奖励活动",
          content: "采购邀请供应商奖励活动",
          img:
            "https://imgcdn.hemiao100.com/ThemePictures/banner2%402x%402x.png",
          bgimg:
            "https://imgcdn.hemiao100.com/ThemePictures/%E9%82%80%E8%AF%B7%E9%A2%86%E7%8E%B0%E9%87%91%402x.png",
          introduce: "采购邀请供应商奖励活动",
          spreadTarget: "store",
          activityFrom: "MyActivity",
          query: "turntable"
        },
        {
          title: "微信广告激励红包",
          content: "微信广告激励红包",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/banner.jpg",
          bgimg:
            "https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/banner_03.png",
          introduce: "微信视频广告",
          spreadTarget: "redpackageVideoAd",
          activityFrom: "MyActivity",
          query: "turntable"
        },
        {
          title: "导购荣誉勋章",
          content: "导购荣誉勋章",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/xunzhangsuolie.png",
          bgimg:
            "https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/medal.jpg",
          introduce: "创建勋章奖励，导购领取勋章享受极速审核。",
          spreadTarget: "medal",
          activityFrom: "MyActivity",
          query: "turntable"
        },
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 创建活动
    toCreateActivity() {
      if(this.row.spreadTarget==="medal"){
        this.$router.push({path:"/guiderCommission/redInvitationact/createABadgeEvent"})
        return;
      }
      let name="";
      if(this.row.spreadTarget==="redpackageVideoAd"){
        name = "SettingRedActNew"
      }else{
        name = "SettingRedAct"
      }
   
      this.$router.push({
        name: name,
        query: {
          spreadTarget: this.row.spreadTarget,
          type: "add"
        }
      });


    },
    toMyActivity(row) {
      if(row.spreadTarget == 'medal'){
        this.$router.push({path:"/guiderCommission/redInvitationact/medalEventManagement?activityType="+row.spreadTarget});
        return;
      }
      this.$router.push({
        name: "RedActManagement",
        query: {
          activityType: row.spreadTarget
        }
      });
    },
    async createdGame(v) {
      this.row = v;
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang='scss' scoped>
.act-content {
  border-radius: 4px;
  margin: 10px;
  padding: 10px;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.gameImg {
  width: 330px;
}
.introduce {
  padding: 0 50px 0;
  p {
    font-size: 14px;
    line-height: 30px;
    font-weight: 900;
  }
}
</style>
